module.exports = __webpack_public_path__ + "static/img/obs.73f1a17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/obs.jpg
// module id = 5bnt
// module chunks = 1